import { io } from "socket.io-client";

const SOCKET_URL = "http://129.153.124.232:3000";

export function createChatSocket(token) {
  return io(SOCKET_URL, {
    auth: { token },
    autoConnect: false,
    transports: ["websocket"],
  });
}
